import React from 'react';

import { icons } from '../images';
import { useLocation } from 'react-router';
import SVG from '../images/svg/SVG.js';
import { useSelector } from 'react-redux';
import selectors from 'selectors/selectors';

const ScreenHeaderTabs = ({ tabs, onTabClick, param }) => {
  const { pathname } = useLocation();
  const paramValue = useSelector((state) => selectors.query(state)[param]);

  const isActive = (tab) => {
    return pathname === tab.slug || tab.subOptionActive || tabs.length === 1 || (paramValue === tab.id && param !== undefined);
  };

  return (
    <div className="screen-tabs">
      {tabs.map((tab, idx) => (
        <a data-title-offset-y={-30} data-title={tab.dataTitle ? tab.dataTitle : null} key={idx} className={`screen-tab ${isActive(tab) ? 'active' : ''} ${tab.subOptionClick ? 'sub-option' : ''} ${tab.subOptionActive === true ? 'sub-option-active' : ''}`} onClick={(e) => onTabClick(e, tab)}>
          {!!tab.icon && <img className={'screen-tab-icon'} src={icons[tab.icon]} alt={tab.icon} />}
          {!!tab.svg && <SVG icon={tab.svg} className={'screen-tab-svg'} />}
          <div className={`screen-tab-label`}>{tab.label}</div>
          {tab.count !== undefined && <div className={`screen-tab-count`}>{tab.count}</div>}
          {tab.subOptionClick ? (
            <div
              onClick={(e) => {
                e.stopPropagation();
                tab.subOptionClick();
              }}
              className={`screen-tab-sub-option ${tab.subOptionClick ? 'sub-option-active' : ''} img-container`}>
              {tab.subOptionIcon ? (
                <>
                  <img src={icons[tab.subOptionIcon]} alt="screen-tab-sub-option" data-title={'View details'} />
                </>
              ) : (
                tab.subOptionText || ''
              )}
            </div>
          ) : null}
          {tab.eventCount !== undefined && <div className={`screen-tab-event-count`}>{tab.eventCount}</div>}
        </a>
      ))}
    </div>
  );
};

export default ScreenHeaderTabs;
